import Sidebar from './common/Sidebar';
import TaskIcon from 'assets/icons/task';
import EditIcon from 'assets/icons/edit';
import ConnectIcon from 'assets/icons/connect';
import { Box, Typography } from '@mui/material';
import SolutionShape from './shapes/SolutionShape';
import ConditionIcon from 'assets/icons/condition';
import ConditionShape from './shapes/ConditionShape';
import ConfirmModal from 'components/modal/ConfirmModal';
import ActionButton from 'components/button/ActionButton';
import SolutionTaskShape from './shapes/SolutionTaskShape';
import useViewWorkFlowHook from './hooks/useViewWorkFlowHook';
import { Controls, ReactFlow, Background } from '@xyflow/react';
import EdgeConfigurationDrawer from './drawer/EdgeConfigurationDrawer';
import NodeConfigurationDrawer from './drawer/NodeConfigurationDrawer';

const EditButton = ({ handleEditFlow, handleViewSolution, handleWorkflowAction, activationStatus }) => {
	return (
		<Box
			sx={{
				gap: 1,
				top: 16,
				right: 16,
				zIndex: 999,
				display: 'flex',
				alignItems: 'center',
				// position: 'absolute',
			}}
		>
			{activationStatus?.toLowerCase() === 'active' && (
				<ActionButton
					variantType="upgrade"
					label="Condition Version"
					tooltip="New Condition Version"
					onClick={() => handleWorkflowAction({ action: 'new_version' })}
				/>
			)}

			{activationStatus?.toLowerCase() === 'active' && (
				<ActionButton
					label="Upgrade"
					tooltip="Upgrade Solution"
					variantType="upgrade"
					onClick={() => handleWorkflowAction({ action: 'Upgrade' })}
				/>
			)}

			{activationStatus?.toLowerCase() !== 'active' && (
				<ActionButton label="Active" tooltip="Active" variantType="add" onClick={() => handleWorkflowAction({ action: 'Active' })} />
			)}

			{activationStatus?.toLowerCase() === 'active' && (
				<ActionButton
					label="Deactivate"
					tooltip="Deactivate"
					variantType="reject"
					onClick={() => handleWorkflowAction({ action: 'Deactivate' })}
				/>
			)}

			<ActionButton onClick={handleViewSolution} variantType="add" label="Solution" tooltip="View Solution" />

			<ActionButton
				label="Edit"
				variantType="edit"
				tooltip="Edit workflow"
				onClick={handleEditFlow}
				startIcon={<EditIcon width="18px" height="18px" color="#00b050" />}
			/>
		</Box>
	);
};

const nodeTypes = {
	solution: SolutionShape,
	condition: ConditionShape,
	solution_task: SolutionTaskShape,
};

// function Sidebar() {
// 	const onDragStart = (event, nodeType) => {
// 		event.dataTransfer.setData('application/reactflow', nodeType);
// 		event.dataTransfer.effectAllowed = 'move';
// 	};

// 	return (
// 		<aside style={{ padding: 10, borderRight: '1px solid #ddd', background: '#fff' }}>
// 			{/* <div
// 				style={{ padding: '10px 10px 5px 10px', background: '#eee', cursor: 'grab', marginBottom: 10 }}
// 				onDragStart={(e) => onDragStart(e, 'solution')}
// 				draggable
// 			>
// 				<ConnectIcon />
// 			</div> */}

// 			<div
// 				style={{
// 					marginBottom: 10,
// 					padding: '10px 10px 5px 10px',
// 					background: '#eee',
// 					cursor: 'grab',
// 				}}
// 				onDragStart={(e) => onDragStart(e, 'solution_task')}
// 				draggable
// 			>
// 				<TaskIcon />
// 			</div>

// 			<div
// 				style={{
// 					padding: '10px 10px 5px 10px',
// 					background: '#eee',
// 					cursor: 'grab',
// 				}}
// 				onDragStart={(e) => onDragStart(e, 'condition')}
// 				draggable
// 			>
// 				<ConditionIcon />
// 			</div>
// 		</aside>
// 	);
// }

const Header = ({ handleEditFlow, handleViewSolution, handleWorkflowAction, activationStatus, nodes }) => {
	const solutionData = nodes?.find((item) => item?.type === 'solution')?.data ?? null;

	return (
		<Box
			sx={{
				display: 'flex',
				marginTop: '40px',
				background: '#fff',
				alignItems: 'center',
				// p: '10px 24px 10px 65px',
				p: '10px 24px 10px 24px',
				justifyContent: 'space-between',
				borderBottom: '1px solid #E5E7EB',
				boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
			}}
		>
			<Box>
				<Typography fontWeight={600} fontSize={18} sx={{ color: solutionData?.solution?.name ? '#1F2937' : '#EF4444' }}>
					{solutionData?.solution?.name ?? 'Please create solution first'}
				</Typography>

				<Typography fontWeight={400} fontSize={14} sx={{ color: solutionData?.solution?.verticalName ? '#6B7280' : '#EF4444' }}>
					Vertical: {solutionData?.solution?.verticalName ?? 'No vertical selected'}
				</Typography>
			</Box>

			<EditButton
				handleEditFlow={handleEditFlow}
				activationStatus={activationStatus}
				handleViewSolution={handleViewSolution}
				handleWorkflowAction={handleWorkflowAction}
			/>
		</Box>
	);
};

const WorkflowView = () => {
	const {
		nodes,
		edges,
		setNodes,
		setEdges,
		showModal,
		modalData,
		isModalOpen,
		flowInstance,
		setShowModal,
		selectedNode,
		selectedEdge,
		handleEditFlow,
		setIsModalOpen,
		setSelectedNode,
		isEdgeModalOpen,
		setSelectedEdge,
		activationStatus,
		reactFlowWrapper,
		handleViewSolution,
		setIsEdgeModalOpen,
		handleActionSubmit,
		handleWorkflowAction,
	} = useViewWorkFlowHook();

	return (
		<>
			<Header
				nodes={nodes}
				handleEditFlow={handleEditFlow}
				activationStatus={activationStatus}
				handleViewSolution={handleViewSolution}
				handleWorkflowAction={handleWorkflowAction}
			/>

			<Box sx={{ display: 'flex', height: '85vh', position: 'relative' }}>
				{/* <Sidebar /> */}

				<Box sx={{ flex: 1 }} ref={reactFlowWrapper}>
					<ReactFlow
						fitView
						nodes={nodes}
						edges={edges}
						nodeTypes={nodeTypes}
						nodesDraggable={false}
						nodesConnectable={false}
						elementsSelectable={false}
						onInit={(instance) => (flowInstance.current = instance)}
						onNodeClick={(event, node) => {
							setSelectedNode(node);
							setIsModalOpen(true);
						}}
						onEdgeClick={(event, edge) => {
							setSelectedEdge(edge);
							setIsEdgeModalOpen(true);
						}}
					>
						<Controls />
						<Background />
					</ReactFlow>

					{/* <EditButton handleEditFlow={handleEditFlow} handleWorkflowAction={handleWorkflowAction} activationStatus={activationStatus} /> */}
				</Box>

				{isModalOpen && selectedNode && (
					<NodeConfigurationDrawer
						nodes={nodes}
						disabled={true}
						node={selectedNode}
						setNodes={setNodes}
						setEdges={setEdges}
						onClose={() => setIsModalOpen(false)}
					/>
				)}

				{isEdgeModalOpen && selectedEdge && (
					<EdgeConfigurationDrawer disabled={true} edge={selectedEdge} setEdges={setEdges} onClose={() => setIsEdgeModalOpen(false)} />
				)}

				{showModal && (
					<ConfirmModal showModal={showModal} modalData={modalData} setShowModal={setShowModal} handleSubmit={handleActionSubmit} />
				)}
			</Box>
		</>
	);
};

export default WorkflowView;
